import React from "react"
import "./style.scss"

const DetailsTabGrid = ({ children }) => {
  return (
    <div className="shared-insights-details-tab">
      {React.Children.map(children, (child, i) =>
        child !== null ? (
          <div key={i} className={`col`}>
            {child}
          </div>
        ) : null
      )}
    </div>
  )
}

export default DetailsTabGrid
